import {
  SAVE_FORM_DATA_PART_ONE,
  SAVE_FORM_DATA_PART_TWO,
  SAVE_FORM_DATA_PART_THREE,

  TREG_FETCH_ALL_STATES_SUCCESS,
  FETCH_ALL_ACTIVE_SKILLS_TREG_SUCCESS,

  REGISTER_TRAINING_CENTRE,
  REGISTER_TRAINING_CENTRE_SUCCESS,
  REGISTER_TRAINING_CENTRE_FAILURE,
  RESET_TRAINING_CENTRE_REG,

  NEXT_FORM_STEP,
  PREVIOUS_FORM_STEP,
  RESET_FORM_STEP,

  OPEN_PART_ONE_POPUP,
  CLOSE_PART_ONE_POPUP,

  OPEN_TC_POPUP,
  CLOSE_TC_POPUP,

  SET_PART_3_PAGE_DIRECTION,
} from "../ActionTypes"

const INIT_STATE = {
  // Part One Data
  trainingTypeId: "",
  skillIds: [],
  skillCenterName: "",
  centerEmail: "",
  centerPhoneNumber: "",
  centerWhatsappNumber: "",
  stateId: "",
  localGovernmentId: "",
  physicalAddress: "",
  closeLandMark: "",

  // Part Two Data
  trainers: [],
  file: "",
  fileName: "",
  fileExtension: "",
  files: [],
  equipments: [], // from sectionfive component

  // Part Three Data
  centerCapacity: "",
  commentOnConduciveness: "",
  commentOnDispute: "",
  courseContent: [],
  commentOnCurriculum: "",
  commentOnImpact: "",
  otherInformation: "",

  // API Responses
  listOfStates: [],
  registeringTrainingCentre: false,
  trainingCentreRegComplete: false,
  trainingCentreRegError: false,

  shipTrainingRegDataToApi: false,
  listOfActiveSkills: [],

  // UI
  activeStep: 0,
  partOnePopupOpen: true,
  tcPopupOpen: false,
  partThreeChangePageDirection: "",   // options: back | next

}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case SAVE_FORM_DATA_PART_ONE: {
      return {
        ...state,
        ...action.payload
      }
    }
    case SAVE_FORM_DATA_PART_TWO: {
      return {
        ...state,
        ...action.payload
      }
    }
    case SAVE_FORM_DATA_PART_THREE: {
      return {
        ...state,
        ...action.payload
      }
    }
    case TREG_FETCH_ALL_STATES_SUCCESS: {
      let newStateList = [];

      action.payload.map((state) => {
        let newLgaList = [];

        state.lgas.map((lga) => {
          newLgaList.push({
            label: lga.lgaName,
            value: lga.lgaid,
          });
        });

        let parsedStateObj = {
          label: state.stateName,
          value: state.stateID,
          lgas: newLgaList,
        };

        newStateList.push(parsedStateObj);
      });

      return {
        ...state,
        listOfStates: newStateList
      }
    }
    case REGISTER_TRAINING_CENTRE: {
      return {
        ...state,
        registeringTrainingCentre: true,
      }
    }
    case REGISTER_TRAINING_CENTRE_SUCCESS: {
      return {
        ...state,
        registeringTrainingCentre: false,
        trainingCentreRegComplete: true,
        trainingCentreRegError: false,
      }
    }
    case REGISTER_TRAINING_CENTRE_FAILURE: {
      return {
        ...state,
        registeringTrainingCentre: false,
        trainingCentreRegComplete: true,
        trainingCentreRegError: true,
      }
    }
    case RESET_TRAINING_CENTRE_REG: {
      return {
        ...state,
        registeringTrainingCentre: false,
        trainingCentreRegComplete: false,
      }
    }
    case FETCH_ALL_ACTIVE_SKILLS_TREG_SUCCESS: {
      return {
        ...state,
        listOfActiveSkills: action.payload
      }
    }
    case NEXT_FORM_STEP: {
      return {
        ...state,
        activeStep: state.activeStep + 1
      }
    }
    case PREVIOUS_FORM_STEP: {
      return {
        ...state,
        activeStep: state.activeStep - 1
      }
    }
    case RESET_FORM_STEP: {
      return {
        ...state,
        activeStep: 0
      }
    }
    case OPEN_PART_ONE_POPUP: {
      return {
        ...state,
        partOnePopupOpen: true
      }
    }
    case CLOSE_PART_ONE_POPUP: {
      return {
        ...state,
        partOnePopupOpen: false
      }
    }
    case OPEN_TC_POPUP: {
      return {
        ...state,
        tcPopupOpen: true
      }
    }
    case CLOSE_TC_POPUP: {
      return {
        ...state,
        tcPopupOpen: false
      }
    }
    case SET_PART_3_PAGE_DIRECTION: {
      return {
        ...state,
        partThreeChangePageDirection: action.payload
      }
    }
    default:
      return state
  }
}


export default reducers;